import { Popover } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getEffectivePlanType } from "../../utils/planType";

type Props = {
  children?: any;
  available?: any;
  titleHeading?: string;
  showAccount?: any;
  showPopup?: any;
  popoverContent?: React.ReactNode;
  learnMoreLink?: string;
  placement?: TooltipPlacement;
};

function PlanToast({ children, available, titleHeading, showAccount, showPopup, popoverContent, learnMoreLink, placement }: Props) {
  const navigate = useNavigate();
  const [plan, setplan] = useState("");

  useEffect(() => {
    setplan(getEffectivePlanType());
  }, []);

  return available.includes(plan) ? (
    // return !false ? (
    <>
      {showPopup ? (
        <Popover 
          content={
            popoverContent ? (
              <div>
                {popoverContent}
                {learnMoreLink && (
                  <p style={{ marginTop: '8px', marginBottom: '0' }}>
                    <button
                      onClick={() => navigate(learnMoreLink)}
                      style={{
                        color: '#1890ff',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: '14px',
                        border: 'none',
                        background: 'none',
                        padding: '0',
                        fontFamily: 'inherit'
                      }}
                    >
                      Learn more
                    </button>
                  </p>
                )}
              </div>
            ) : (
              <p>{titleHeading}</p>
            )
          } 
          placement={placement || "topLeft"}
        >
          {children}
        </Popover>
      ) : (
        <>{children}</>
      )}
    </>
  ) : (
    <>
      <Popover
        // style={{zIndex:1000}}
        content={
          <p
            className="hanker2 upgradePlanToast"
            onClick={() => {
              window.open(`/settings?tab=upgradeplan`, "_blank");
            }}
          >
            Upgrade plan
          </p>
        }
        placement={placement || "top"}
        title={titleHeading}
      >
        <div className="disabledLayer"></div>
        {children}
      </Popover>
    </>
  );
}

export default PlanToast;
